import {ProTableColumnsType} from './index';
import {Key, useMemo} from 'react';
import md5 from 'blueimp-md5';
import {useServerStorage} from '../../Utils/Hooks/useServerStorage';

interface TableState {
    visibleColumnKeys: Key[];
    sortedColumnKeys: Key[];
}

export default function useStoreColumns<RecordType>(
    columns: ProTableColumnsType<RecordType>,
) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const hash = useMemo(() => md5(JSON.stringify(columns)), [columns]);

    // const [defaultTableState, setDefaultTableState] = useAtom(storeAtom(hash));
    const [defaultTableState, setDefaultTableState] = useServerStorage<
        TableState | undefined
    >(hash, undefined);

    function onTableChange(data: TableState) {
        setDefaultTableState(data);
    }

    return {columns, onTableChange, defaultTableState};
}
